<template>
    <div>
        <div v-if="!showRecoveryCode">
            <p class="text-slate-800 mb-4">
                Enter the code in your authenticator app
            </p>

            <VOtpInput
                ref="otpInput"
                input-classes="otp-input"
                inputType="numeric"
                :num-inputs="6"
                v-model:value="otpCode"
                :should-auto-focus="true"
                :should-focus-order="true"
                @on-complete="loginStore.verifyCode()"
                class="mb-4"
            />
        </div>

        <p class="text-sm text-slate-800 mb-6" v-if="!showRecoveryCode">
            No access to the app?
            <a
                class="link"
                @click.prevent="showRecoveryCode = !showRecoveryCode"
                href="#recovery-code"
            >
                Use recovery code
            </a>
        </p>

        <div v-if="showRecoveryCode" class="mb-6">
            <p class="text-slate-800 text-sm mb-6">
                If you are unable to access your authenticator app, enter one of
                your recovery codes to verify your idenity.
            </p>
            <UiInput
                type="text"
                id="recovery-code"
                name="recovery_code"
                label="Recovery code"
                :options="{
                    inputClass:
                        ' placeholder:text-left placeholder:font-light ',
                }"
                placeholder="Enter recovery code"
                v-model:inputValue="recoveryCode"
                :errors="formErrors"
                autofocus
            />
        </div>

        <Errors :errors="errors" class="mb-4" />

        <ActionButton
            @clicked="loginStore.verifyCode()"
            label="Continue sign in"
            :loading="loading"
            classes="bg-slate-800 hover:bg-slate-600 text-sm px-4 py-2.5 rounded shadow transition-colors text-white font-medium w-full mb-3"
        />

        <button
            v-if="!showRecoveryCode"
            class="w-full flex items-center gap-2 justify-center px-4 py-2.5 bg-white rounded text-slate-800 text-sm font-medium hover:bg-slate-50 transition-colors"
            @click="loginStore.cancelTotp()"
        >
            Back to sign in
        </button>

        <button
            v-if="showRecoveryCode"
            class="w-full flex items-center gap-2 justify-center px-4 py-2.5 bg-white rounded text-slate-800 text-sm font-medium hover:bg-slate-50 transition-colors"
            @click="loginStore.gotoTwoFactor()"
        >
            Back to sign in
        </button>
    </div>
</template>
<script setup>
import { storeToRefs } from 'pinia';
import { useLoginStore } from '@/store/login';
import UiInput from '@/components/ui/inputs/ui-input.vue';
import ActionButton from '@/components/action-button.vue';
import Errors from '@/components/errors.vue';
import VOtpInput from 'vue3-otp-input';

const loginStore = useLoginStore();
const { otpCode, loading, recoveryCode, showRecoveryCode, errors, formErrors } =
    storeToRefs(loginStore);
</script>
